import React from "react";
import headerStyles from "../../Header.css";
import styles from "./MegaMenu.css";

export default function MegaMenu({
  activeMenuIndex,
  practical_menu_info,
  opening_hours,
  setActiveMenuIndex,
  mode = "normal",
  onMenuToggle,
  children,
  isThy,
}) {
  const isOpen = activeMenuIndex !== undefined || mode === "other";

  return (
    <div
      onClick={() => {
        setActiveMenuIndex(undefined);
        onMenuToggle();
      }}
      className={[
        styles.MegaMenuWrapper,
        isOpen ? styles.MegaMenuWrapper_active : "",
      ].join(" ")}
    >
      <div
        className={[
          "container-fluid",
          styles.MegaMenu,
          isOpen ? styles.MegaMenu_active : "",
        ].join(" ")}
      >
        <div
          className={[
            "row",
            headerStyles.Row,
            styles["MegaMenuRow"],
            styles["MegaMenuRow_divider"],
          ].join(" ")}
        >
          {/* Grid placeholder 
          <div></div>
          */}
          <div className={styles["MegaMenuRow-Divider"]}></div>
          <div className={styles["MegaMenuRow-Divider"]}></div>
        </div>
        <div
          className={["row", headerStyles.Row, styles["MegaMenuRow"]].join(" ")}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {/* Grid placeholder 
          <div></div>
          */}
          <div
            className={[styles.Sections, isThy && styles.Sections_thy].join(
              " "
            )}
          >
            <div className={styles["Sections-Primary"]}>{children}</div>
            <div className={styles.SecondarySection}>
              <p dangerouslySetInnerHTML={{ __html: opening_hours.message }} />
              <div
                dangerouslySetInnerHTML={{
                  __html: practical_menu_info,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header/Components/MegaMenu/MegaMenu.js